import $ from 'jquery';
import { PaymentCalculatorFactory, Formatter } from '@dealersites/dealersite-js-core';
import { IncentivesService } from './services/incentives';

import './bottom-bar';
import './summary';
import './configure';

const dsp = (global.dsp = global.dsp || {});
if (!dsp.incentives) {
  dsp.incentives = IncentivesService;
}

$(document).ready(() => {
  $('.IncentiveValue .js-payment').each(function () {
    const $payment = $(this);

    const calcInputs = {
      price: $payment.data('price'),
      down: $payment.data('down'),
      term: $payment.data('term'),
      rate: $payment.data('rate'),
      tradein: $payment.data('tradein'),
      tax: 0,
    };

    const calcType = $payment.data('calculator');
    if (calcType === 'lease') {
      calcInputs.residual = $payment.data('residual');
    }

    const calculator = PaymentCalculatorFactory.createCalculator(calcType, calcInputs);
    if (calculator) {
      calculator.calculate();
      $payment.text(Formatter.price(calculator.payments.weekly, 2));
    }
  });
});
